var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = (scopeName, key) => {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = (scope, key) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key) => {
	var versions = scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = (scope, scopeName, key, requiredVersion) => {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = (scope, key, requiredVersion) => {
	var versions = scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = (scope, scopeName, key, requiredVersion) => {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warn = (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var warnInvalidVersion = (scope, scopeName, key, requiredVersion) => {
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var init = (fn) => (function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
});

var load = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key) => {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init((scopeName, scope, key, version) => {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init((scopeName, scope, key, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init((scopeName, scope, key, version, fallback) => {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	1091: () => (loadSingletonVersionCheckFallback("default", "react", [1,19,1,1], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(6540))))))),
	8957: () => (loadSingletonVersionCheckFallback("default", "react-dom", [1,19,1,1], () => (__webpack_require__.e(3342).then(() => (() => (__webpack_require__(961))))))),
	5435: () => (loadStrictVersionCheckFallback("default", "react-router", [1,5,3,3], () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(6347)]).then(() => (() => (__webpack_require__(6347))))))),
	2843: () => (loadStrictVersionCheckFallback("default", "oasis-os-react", [1,9,3,3], () => (Promise.all([__webpack_require__.e(8303), __webpack_require__.e(1091), __webpack_require__.e(9649)]).then(() => (() => (__webpack_require__(684))))))),
	5514: () => (loadStrictVersionCheckFallback("default", "react-router-dom", [1,5,3,3], () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(5435), __webpack_require__.e(7006)]).then(() => (() => (__webpack_require__(4625))))))),
	6212: () => (loadStrictVersionCheckFallback("default", "@ionic/react", [4,8,7,2], () => (Promise.all([__webpack_require__.e(9909), __webpack_require__.e(8957), __webpack_require__.e(9449)]).then(() => (() => (__webpack_require__(9909))))))),
	4126: () => (loadSingletonVersionCheckFallback("default", "oasis-auth", [1,9,2,8], () => (Promise.all([__webpack_require__.e(4344), __webpack_require__.e(7154), __webpack_require__.e(7363), __webpack_require__.e(2858)]).then(() => (() => (__webpack_require__(7154))))))),
	3338: () => (loadStrictVersionCheckFallback("default", "oasis-os-contentful", [1,9,3,6], () => (Promise.all([__webpack_require__.e(6093), __webpack_require__.e(3978), __webpack_require__.e(2634)]).then(() => (() => (__webpack_require__(6093))))))),
	3677: () => (loadStrictVersionCheckFallback("default", "oasis-os-provider-messaging", [1,9,2,1], () => (Promise.all([__webpack_require__.e(540), __webpack_require__.e(1528)]).then(() => (() => (__webpack_require__(1528))))))),
	6996: () => (loadSingletonVersionCheckFallback("default", "oasis-os-theming", [1,9,2,5], () => (Promise.all([__webpack_require__.e(7740), __webpack_require__.e(3649)]).then(() => (() => (__webpack_require__(6030))))))),
	8438: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(9065), __webpack_require__.e(1091)]).then(() => (() => (__webpack_require__(4089))))))),
	474: () => (loadStrictVersionCheckFallback("default", "@ionic/react-router", [4,8,2,5], () => (Promise.all([__webpack_require__.e(7929), __webpack_require__.e(5616), __webpack_require__.e(2386)]).then(() => (() => (__webpack_require__(5616))))))),
	820: () => (loadStrictVersionCheckFallback("default", "@ionic/core", [4,8,7,2], () => (Promise.all([__webpack_require__.e(2693), __webpack_require__.e(8996)]).then(() => (() => (__webpack_require__(2693))))))),
	1166: () => (loadSingletonVersionCheckFallback("default", "oasis-feature-api", [4,9,4,8], () => (Promise.all([__webpack_require__.e(2230), __webpack_require__.e(3038)]).then(() => (() => (__webpack_require__(2230))))))),
	7563: () => (loadSingletonVersionCheckFallback("default", "oasis-os-common", [1,9,8,4], () => (Promise.all([__webpack_require__.e(4344), __webpack_require__.e(2643), __webpack_require__.e(8957), __webpack_require__.e(4083), __webpack_require__.e(4624), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(2643))))))),
	2386: () => (loadStrictVersionCheckFallback("default", "@ionic/react", [4,8,7,2], () => (Promise.all([__webpack_require__.e(2406), __webpack_require__.e(8957), __webpack_require__.e(4140)]).then(() => (() => (__webpack_require__(2406))))))),
	7363: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(9677)]).then(() => (() => (__webpack_require__(2671))))))),
	4083: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(4429), __webpack_require__.e(1091)]).then(() => (() => (__webpack_require__(1183))))))),
	3038: () => (loadStrictVersionCheckFallback("default", "oasis-os-react", [1,9,3,3], () => (Promise.all([__webpack_require__.e(7115), __webpack_require__.e(1091), __webpack_require__.e(9388)]).then(() => (() => (__webpack_require__(7115))))))),
	4624: () => (loadSingletonVersionCheckFallback("default", "oasis-feature-api", [4,9,4,8], () => (__webpack_require__.e(1134).then(() => (() => (__webpack_require__(1134))))))),
	3978: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(5086)]).then(() => (() => (__webpack_require__(5086))))))),
	9388: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(2694)]).then(() => (() => (__webpack_require__(313))))))),
	9649: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(189)]).then(() => (() => (__webpack_require__(189))))))),
	7740: () => (loadSingletonVersionCheckFallback("default", "oasis-os-utils", [1,9,3,5], () => (Promise.all([__webpack_require__.e(5564), __webpack_require__.e(30)]).then(() => (() => (__webpack_require__(5920))))))),
	5307: () => (loadStrictVersionCheckFallback("default", "oasis-os-provider-messaging", [1,9,2,1], () => (Promise.all([__webpack_require__.e(540), __webpack_require__.e(9975)]).then(() => (() => (__webpack_require__(9975)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"714": [
		474,
		820,
		1166,
		7563
	],
	"1091": [
		1091
	],
	"2386": [
		2386
	],
	"2843": [
		2843
	],
	"3038": [
		3038
	],
	"3978": [
		3978
	],
	"4083": [
		4083
	],
	"4624": [
		4624
	],
	"5435": [
		5435
	],
	"5514": [
		5514
	],
	"6050": [
		5307
	],
	"6057": [
		8438
	],
	"6212": [
		6212
	],
	"6234": [
		4126,
		3338,
		3677,
		6996
	],
	"7363": [
		7363
	],
	"7740": [
		7740
	],
	"8957": [
		8957
	],
	"9388": [
		9388
	],
	"9649": [
		9649
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}